import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ReplenPage } from '@/components/Replen/ReplenPage'
import { replenSearchSchema, withoutReplenDefaults } from '@/components/Replen/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/replen/')({
  validateSearch: replenSearchSchema,
  component: ReplenRoute,
})

function ReplenRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ReplenPage
      search={search}
      onSearchChange={(next) => void navigate(inPageSearch(withoutReplenDefaults, next))}
    />
  )
}
